import { useState } from "react";
import { toolIcons } from "../../Assets/images/image";
import styles from "../Reports/report.module.css";
import SlideBox from "../../common/SlideBox/SlideBox";
import Merchantgroup from "../TelegramBot/Merchantgroup";
import Admingroup from "../TelegramBot/Admingroup";
import AddUserForm from "./Component/AddUser";
import ChatUI from "./Component/ChatUI";
import MerchantAlerts from "../TelegramBot/MerchantAlerts";
import ManageBroadcasts from "../TelegramBot/ManageBroadcasts";

// Lookup for components
const supportComponents = {
  MerchantGroup: Merchantgroup,
  AdminGroup: Admingroup,
  Adduser: AddUserForm,
  Chat: ChatUI,
  MerchantAlerts: MerchantAlerts,
  TelegramBroadCast: ManageBroadcasts,
};

// Config for reports
const supportConfig = [
  {
    key: "MerchantGroup",
    label: "Merchant Group",
    icon: toolIcons?.MerchantPanel,
  },
  {
    key: "Adduser",
    label: "Add User",
    icon: toolIcons?.UserPng,
  },
  {
    key: "Chat",
    label: "Chat",
    icon: toolIcons?.MDR,
  },
  {
    key: "AdminGroup",
    label: "Admin Group",
    icon: toolIcons?.HoldDepo,
  },
  {
    key: "MerchantAlerts",
    label: "Merchant Alerts",
    icon: toolIcons?.FlagManagement,
  },
  {
    key: "TelegramBroadCast",
    label: "Telegram BroadCast",
    icon: toolIcons?.FlagManagement,
  },
];

const SupportSection = () => {
  const [flag, setFlag] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const toggleRightBar = (type) => {
    if (type) {
      setSelectedReport(type);
    }
    setFlag(!flag);
  };

  const SelectedComponent = selectedReport
    ? supportComponents[selectedReport]
    : null;

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="card card-inverse card-primary text-center">
          <div className="card-body pb-1">
            <SlideBox
              flag={flag}
              toggleRightBar={toggleRightBar}
              type1={selectedReport}
            >
              {SelectedComponent && (
                <SelectedComponent
                  type1={selectedReport}
                  toggleRightBar={toggleRightBar}
                />
              )}
            </SlideBox>

            <div className="row text-center text-lg-start">
              {supportConfig.map(({ key, label, icon }) => (
                <div
                  key={key}
                  className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["report-icon"]}`}
                >
                  <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    onClick={() => toggleRightBar(key)}
                  >
                    <img
                      className="img-fluid img-thumbnail"
                      src={icon}
                      style={{ height: "60px", width: "auto" }}
                      alt={label}
                    />
                    <h5 className="mt-3 text-primary text-md text-sm">
                      {label}
                    </h5>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportSection;
